<template>
  <ts-offcanvas
    :id="id"
    placement="start"
    panel-class="ts-advanced-offcanvas"
    :labelledby="`${id}-title`"
    :no-close-on-route-change="noCloseOnRouteChange"
    @shown="$emit('shown')"
    @hidden="$emit('hidden')"
    @change="$emit('change', $event)"
  >
    <template #default="{ close }">
      <div class="ts-advanced-form d-flex flex-column h-100">
        <div class="offcanvas-header ts-panel-header">
          <div class="d-flex align-items-center gap-3">
            <div class="ts-panel-title-icon d-flex align-items-center justify-content-center">
              <i class="bi bi-sliders" aria-hidden="true"></i>
            </div>
            <h2 :id="`${id}-title`" class="offcanvas-title ts-panel-title fw-bold">{{ title }}</h2>
          </div>
          <button class="btn-close" type="button" :aria-label="closeLabel" @click="close"></button>
        </div>

        <div class="offcanvas-body ts-panel-body">
          <div v-if="subtitle" class="search-panel-label">{{ subtitle }}</div>
          <slot :close="close" />
        </div>

        <div v-if="$scopedSlots.footer" class="ts-panel-footer ts-advanced-footer">
          <slot name="footer" :close="close" />
        </div>
      </div>
    </template>
  </ts-offcanvas>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import TsOffcanvas from '@/components/Talentspace/layout/TsOffcanvas.vue';

// "Erweiterte Suche" panel of the design. Every filter (jobs, applicants, courses, companies,
// map, apprenticeships, places) renders its fields inside; the panel opens with v-b-toggle.<id>.
@Component({
  components: { TsOffcanvas },
})
export default class TsFilterPanel extends Vue {
  @Prop({ required: true }) readonly id!: string;

  @Prop({ required: true }) readonly title!: string;

  // e.g. "Stellensuche" above the first group
  @Prop({ default: '' }) readonly subtitle!: string;

  @Prop({ type: Boolean, default: false }) readonly noCloseOnRouteChange!: boolean;

  get closeLabel() {
    return AppModule.translation[2511];
  }
}
</script>
